/**
 * 설치 위치 셀: 텍스트가 길면 셀 너비에 맞춰 폰트 크기를 줄인다.
 */
import { useEffect, useRef } from 'react';

const MIN_SCALE = 0.65;

interface Props {
  text: string;
  fontPx?: number; // 테이블 폰트(부모) 크기. 변경되면 재-fit 해 stale 축소(헤더보다 작아 보임)를 방지
}

const LocationLabel = ({ text, fontPx }: Props) => {
  const wrapRef = useRef<HTMLSpanElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const wrap = wrapRef.current;
    const el = textRef.current;
    if (!wrap || !el) return undefined;

    const fit = () => {
      el.style.fontSize = '';
      const baseSize = parseFloat(getComputedStyle(el).fontSize);
      if (!baseSize || wrap.clientWidth <= 0) return;

      const minSize = baseSize * MIN_SCALE;
      let size = baseSize;
      el.style.fontSize = `${size}px`;

      while (size > minSize && el.scrollWidth > wrap.clientWidth) {
        size -= 0.5;
        el.style.fontSize = `${size}px`;
      }
    };

    fit();
    const observer = new ResizeObserver(fit);
    observer.observe(wrap);
    return () => observer.disconnect();
    // fontPx: 테이블 폰트가 마운트 후 커질 때(반응형) 명시 px 가 stale 되지 않도록 재-fit
  }, [text, fontPx]);

  return (
    <span ref={wrapRef} className='loc-label-fit'>
      <span ref={textRef} className='loc-label-text'>
        {text}
      </span>
    </span>
  );
};

export default LocationLabel;
